import { useEffect, useRef, useState, useCallback } from 'react';

const useWebSocket = (token) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const connect = useCallback(() => {
    if (!token || socketRef.current) return;

    // Change this to your server URL
    const wsUrl = `ws://localhost:8080/ws?token=${token}`;   // ← Update for production
    // For production use: wss://yourdomain.com/ws?token=...

    const socket = new WebSocket(wsUrl);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log("✅ WebSocket Connected");
      setIsConnected(true);
    };

    socket.onmessage = (event) => {
      try {
        const eventData = JSON.parse(event.data);
        console.log("📨 Received WS event:", eventData);

        if (eventData.type === "notification") {
          setNotifications(prev => [eventData.data, ...prev]);
          // Optional: Show toast notification
        }
        // You can handle other types: "typing:start", "match", etc.
      } catch (e) {
        console.error("Failed to parse WS message", e);
      }
    };

    socket.onclose = (event) => {
      console.log("❌ WebSocket Disconnected", event.code);
      setIsConnected(false);
      socketRef.current = null;

      // Auto-reconnect after 3 seconds
      setTimeout(() => {
        if (token) connect();
      }, 3000);
    };

    socket.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };
  }, [token]);

  useEffect(() => {
    connect();

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [connect]);

  // Function to manually send messages if needed
  const sendMessage = (type, data) => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify({ type, data }));
    }
  };

  return { isConnected, notifications, sendMessage };
};

export default useWebSocket;